type LoaderProps = {
  width?: string;
  height?: string;
};

export default function Loader({ width = '82', height = '82' }: LoaderProps) {
  return (
    <div className="animate-spin">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 82 82"
        fill="none"
      >
        <path
          d="M77.0087 34.6351L77.4262 37.8065L77.5657 41.0022L77.4262 44.1979L77.0087 47.3693L76.3164 50.4922L75.3545 53.5429L74.1304 56.4982L72.6534 59.3355L70.9347 62.0333L68.9874 64.5711L66.8263 66.9294L64.468 69.0905L61.9302 71.0378L59.2324 72.7565L56.3951 74.2335L53.4398 75.4576L50.3891 76.4195L47.2662 77.1118L44.0948 77.5293L40.8991 77.6689L37.7034 77.5293L34.532 77.1118L31.4091 76.4195L28.3583 75.4576L25.4031 74.2335L22.5658 72.7565L19.868 71.0378L17.3302 69.0905L14.9718 66.9294L12.8108 64.5711L10.8635 62.0333L9.14482 59.3355L7.6678 56.4982L6.44369 53.5429L5.48181 50.4922L4.78947 47.3693L4.37195 44.1979L4.23242 41.0022L4.37195 37.8065L4.78947 34.6351L5.48181 31.5122L6.44369 28.4615L7.6678 25.5062L9.14482 22.6689L10.8635 19.9711L12.8108 17.4333L14.9718 15.0749L17.3302 12.9139L19.868 10.9666L22.5658 9.24793L25.4031 7.77091L28.3583 6.5468L31.4091 5.58492L34.532 4.89258"
          stroke="#CCD8F9"
          strokeWidth="8.33333"
          strokeLinecap="round"
        />
        <path
          d="M47.2656 4.89258L50.3886 5.58492L53.4393 6.5468L56.3945 7.77091L59.2319 9.24793L61.9297 10.9666L64.4674 12.9139L66.8258 15.0749L68.9868 17.4333L70.9341 19.9711L72.6528 22.6689"
          stroke="#3B3B98"
          strokeWidth="8.33333"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}
